export const FT_PLATFORM_FILES = "ft platform files";
export const FMX_PLATFORM_FILES = "fmx platform files";
export const MAIN_CONFIGURATION = "main configuration";
